import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/common/Dialog'
import VoiceBoxListing from './VoiceBoxListing'

const SpeechDialogVoices: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation()
  const title = t('ls_generic_generate_speech_choose_performer')
  return (
    <>
      <Dialog.Header onClose={onClose}>
        <span className="text-[16px] font-semibold">{title}</span>
      </Dialog.Header>
      <div className="flex flex-1 flex-row">
        <VoiceBoxListing />
      </div>
    </>
  )
}

export default SpeechDialogVoices
